/**
 * Route paths for the worker module.
 *
 * Kept dependency-free on purpose (no UI/service imports): `authUtils.ts` — which `services/api.config.ts`
 * itself depends on for `handleUnAuthorized` — needs these paths for `MODULE_ROUTE_MAP`. When this used to
 * live in `worker/constants.tsx` (which imports `AccountService` from the `services` barrel), it created an
 * import cycle: `api.config.ts` → `authUtils.ts` → `worker/constants.tsx` → `services` barrel →
 * `auth.service.ts` → `api.config.ts` again, throwing "Cannot access 'APIInstance' before initialization".
 * Keep this file free of anything beyond plain constants.
 */
export const WORKER_ROUTES = {
  root: "/workers",
  details: "/worker/:id",
  particulars: "/worker/:id/particulars",
  addWork: "/add-work",
  addWorkEntry: "/add-work/entry",
  editWork: "/edit-work/:id",
  editWorkBulk: "/edit-work/bulk",
  payment: "/worker/:workerId/payment/:paymentId",
  work: "/worker/:workerId/work/:workId",
} as const;
